import React, { Component, useEffect, useState } from "react";
import { Confitti } from "../../../components/atoms/confetti";
import { BASE_URL } from "../../../config";

const Verification = (props) => {
  const [result, setResult] = useState(null);
  const [counter, setCounter] = useState(null);
  const urlRedirect = "https://borrower.klikcair.com/";

  useEffect(() => {
    if (counter === 0) {
      window.location.replace(urlRedirect);
      return;
    }
    const id = setInterval(() => {
      setCounter(counter - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [counter]);

  useEffect(() => {
    const checkVerification = async () => {
      const { verificationCode, id } = props.match.params;
      const data = { borrower: { id, verificationCode } };
      const res = await fetch(`${BASE_URL}/borrower/verification/email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });
      const resJson = await res.json();
      resJson.status = {
        ...resJson.status,
        statusCode: res.status,
      };
      setResult(resJson);
      res.ok && setCounter(6);
    };
    checkVerification();
  }, []);

  const DisplayResult = () => {
    const { status } = result;
    return (
      <>
        <h1>{status.message}</h1>
        {status.statusCode === 200 ? (
          <span>
            Anda akan diarahkan kehalaman login
            {counter && counter > 0 ? (
              ` dalam waktu ${counter}`
            ) : (
              <a href={urlRedirect}> Klik Disini</a>
            )}
          </span>
        ) : (
          <a href={urlRedirect}>Kembali ke halaman Login</a>
        )}
      </>
    );
  };

  return (
    <div className="verification-wrapper">
      {result && result.status.statusCode === 200 && <Confitti />}
      {!result ? (
        <h1>Tunggu Sebentar, Sedang dilakukan pengecekan.</h1>
      ) : (
        <DisplayResult />
      )}
    </div>
  );
};

export default Verification;
